import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Checkbox, Card, CardContent,
  FormControlLabel,
  Button,
  TextField,
  Divider,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import axios from "axios";
import APS_URL from "../../utils/APS_URL";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setDateSystemStatus } from "../../slice/authSlice";
import { border } from "@mui/system";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    padding: "2rem",
  },
  "& .MuiDialog-paper": {
    backgroundColor: "#121212",
    opacity: 0.85,
    color: "#ffffff",
    width: 400,
    border: "1px solid #464646",
  },
}));

const DialogHeader = styled(Box)(({ theme }) => ({
  backgroundColor: "#000000",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0.5rem 1.5rem",
}));

const DialogSection = styled(Box)(({ theme }) => ({
  padding: "1rem",
  backgroundColor: "#000000",
}));

const SectionContent = styled(Box)(({ theme }) => ({
  padding: "1rem",
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiCheckbox-root": {
    color: "#ffffff",
    "&.Mui-checked": {
      color: "#1976d2",
    },
    "&.Mui-disabled": {
      color: "#666666",
    },
    "&:hover:not(.Mui-disabled)": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
  "& .MuiFormControlLabel-label": {
    color: "#ffffff !important",
    cursor: "pointer",
  },
  "& .MuiFormControlLabel-label.Mui-disabled": {
    color: "#666666 !important",
    cursor: "default",
  },
  cursor: "pointer",
  "&.Mui-disabled": {
    cursor: "default",
  },
}));
const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    color: "#ffffff !important",
    backgroundColor: "rgba(255, 255, 255, 0.05)",
  },
  "& .MuiInputBase-input": {
    color: "#ffffff !important",
  },
  "& .MuiInputLabel-root": {
    color: "#ffffff !important",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#ffffff !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#464646 !important",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#ffffff !important",
  },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#1976d2 !important",
  },
  "& .MuiSvgIcon-root": {
    color: "#ffffff !important",
  },
}));

function DateModal({ open , onReferenceDateChange = () => {} }) {
  const { group_code, project_code } = useParams();
  const [dateOption, setDateOption] = useState("current"); // 'current' or 'custom'
  
  //const [useCurrentDate, setUseCurrentDate] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  //const [dateSelectionEnabled, setDateSelectionEnabled] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    async function fetchData() {
      try {
        const result = await axios.get(
          APS_URL +
            `/api/dt/getSystem?group_code=${group_code}&project_code=${project_code}`
        );
        const data = result.data.key;
        if (data === "use_current") {
          setDateOption('current');
          // setUseCurrentDate(true);
          // setDateSelectionEnabled(false);
          setSelectedDate(null);
        } else if (data === "use_custom") {
          setDateOption('custom');
          // setDateSelectionEnabled(true);
          // setUseCurrentDate(false);
          setSelectedDate(dayjs(result.data.value));
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (open) {
      fetchData();
    }
  }, [open, group_code, project_code]);
  if (!open) return null;
  const handleClose = () => dispatch(setDateSystemStatus(false));
  const handleUseCurrentDateChange = (event) => {
    setDateOption('current');
    setSelectedDate(null);
    // setUseCurrentDate(event.target.checked);
    // if (event.target.checked) {
    //   setDateSelectionEnabled(false);
    //   setSelectedDate(null);
    // }
  };
  const handleDateSelectionEnabledChange = (event) => {
    setDateOption('custom');
    // setDateSelectionEnabled(event.target.checked);
    // if (event.target.checked) {
    //   setUseCurrentDate(false);
    // }
  };
  const handleSave = async () => {
    // if (useCurrentDate) {
    if (dateOption === 'current') {
      const res = await axios.put(APS_URL + `/api/dt/updateSystem`, {
        project_code,
        group_code,
        key: "use_current",
        value: "1",
      });
      if (res.status === 200) {
        toast.success("업데이트 하였습니다.");
        handleClose();
      }
      onReferenceDateChange(dayjs().format("YYYY-MM-DD HH:mm:ss")); // 20251002 jsh 추가
    } //else if (dateSelectionEnabled && selectedDate) {
    else if (dateOption === 'custom' && selectedDate) {
      const res = await axios.put(APS_URL + `/api/dt/updateSystem`, {
        project_code,
        group_code,
        key: "use_custom",
        value: selectedDate.format("YYYY-MM-DD"),
      });
      if (res.status === 200) {
        toast.success("업데이트 하였습니다.");
        handleClose();
      }
      onReferenceDateChange(selectedDate.format("YYYY-MM-DD HH:mm:ss")); // 20251002 jsh 추가
    } //else if (dateSelectionEnabled && !selectedDate) {
    else if (dateOption === 'custom' && !selectedDate) {
      toast.info("적용할 날짜를 선택해 주세요.");
    } else {
      toast.info("체크박스를 선택해 주세요.");
    }
  };

  // 렌더링
  return(
    <StyledDialog
      open={open}
      onClose={handleClose}
      // ModalProps={{ keepMounted: true}}
      slotProps={{
        root: {               // ⬅️ Modal(루트) 슬롯으로 전달
          keepMounted: true,
        },
        backdrop: {
          sx: {
            backdropFilter: 'blur(2px)',
            WebkitBackdropFilter: 'blur(2px)',
            backgroundColor: 'rgba(0,0,0,0.35)',
          },
        },
      }}
    >
      <DialogHeader>
        <Typography sx={{ margin: 0, fontSize: "1.5em", fontWeight: 500, color: "#ffffff",}}>
          데이터 기준 날짜 설정
        </Typography>
      </DialogHeader>
      <Divider />
      <SectionContent sx={{ display: 'flex', justifyContent: 'center' }}>
        <StyledFormControlLabel
          label="오늘 날짜"
          control={
            <Checkbox
              checked={dateOption === 'current'}
              // checked={useCurrentDate}
              onChange={handleUseCurrentDateChange}
              //disabled={dateSelectionEnabled}
            />
          }
        />
        <StyledFormControlLabel
          control={
            <Checkbox
              checked={dateOption === 'custom'}
              // checked={dateSelectionEnabled}
              onChange={handleDateSelectionEnabledChange}
              //disabled={useCurrentDate}
            />
          }
          label="특정 날짜"
        />
      </SectionContent>
      <SectionContent
        sx={{
          opacity: dateOption === 'custom' ? 1 : 0.5,
          pointerEvents: dateOption === 'custom' ? "auto" : "none",
          // opacity: useCurrentDate ? 0.5 : 1,
          // pointerEvents: useCurrentDate ? "none" : "auto",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="날짜 선택"
              value={selectedDate}
              onChange={(newValue) => setSelectedDate(newValue)}
              disabled={dateOption === 'current'}
              // disabled={useCurrentDate}
              format="YYYY/MM/DD"
              slotProps={{
                textField: {
                  fullWidth: true,
                  sx: {
                    "& .MuiInputBase-root": {
                      color: "#ffffff !important",
                      backgroundColor: "rgba(255, 255, 255, 0.05)",
                    },
                    "& .MuiInputBase-input": {
                      color: "#ffffff !important",
                    },
                    "& .MuiInputLabel-root": {
                      color: "#ffffff !important",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#ffffff !important",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#464646 !important",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ffffff !important",
                    },
                    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#1976d2 !important",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#ffffff !important",
                    },
                  },
                },
                popper: {
                  sx: {
                    "& .MuiPaper-root": {
                      backgroundColor: "#121212 !important",
                      color: "#ffffff !important",
                    },
                    "& .MuiPickersDay-root": {
                      color: "#ffffff !important",
                    },
                    "& .MuiPickersDay-root.Mui-selected": {
                      backgroundColor: "#1976d2 !important",
                    },
                    "& .MuiPickersCalendarHeader-root": {
                      color: "#ffffff !important",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#ffffff !important",
                    },
                  },
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      </SectionContent>
      <Divider />
      <DialogActions sx={{ padding: "1rem", backgroundColor: "#121212" }}>
        <Button
          onClick={handleSave}
          variant="contained"
          size="small"
          sx={{ minWidth: 80 }}
        >
          저장
        </Button>
        <Button
          onClick={handleClose}
          variant="outlined"
          size="small"
          sx={{
            minWidth: 80,
            color: "#ffffff",
            borderColor: "#464646",
            "&:hover": {
              borderColor: "#ffffff",
            },
          }}
        >
          닫기
        </Button>
      </DialogActions>
    </StyledDialog>
  );

  // return (
  //   <StyledDialog
  //     open={open}
  //     onClose={handleClose}
  //     ModalProps={{
  //       keepMounted: true,
  //     }}
  //   >
  //     <DialogHeader>
  //       <Typography
  //         sx={{
  //           margin: 0,
  //           fontSize: "1.5em",
  //           fontWeight: 500,
  //           color: "#ffffff",
  //         }}
  //       >
  //         데이터 기준 날짜 설정
  //       </Typography>
  //     </DialogHeader>
  //     <Divider />
  //     <DialogSection>
  //       <Typography
  //         sx={{
  //           margin: 0,
  //           fontSize: "1.2em",
  //           fontWeight: 500,
  //           mb: 1,
  //           color: "#ffffff",
  //         }}
  //       >
  //         오늘 날짜 사용
  //       </Typography>
  //     </DialogSection>
  //     <SectionContent>
  //       <StyledFormControlLabel
  //         control={
  //           <Checkbox
  //             checked={useCurrentDate}
  //             onChange={handleUseCurrentDateChange}
  //             disabled={dateSelectionEnabled}
  //           />
  //         }
  //         label="오늘 날짜 사용하기"
  //       />
  //     </SectionContent>
  //     <Divider />
  //     <DialogSection>
  //       <Typography
  //         sx={{
  //           margin: 0,
  //           fontSize: "1.2em",
  //           fontWeight: 500,
  //           mb: 1,
  //           color: "#ffffff",
  //         }}
  //       >
  //         특정 날짜 선택
  //       </Typography>
  //     </DialogSection>
  //     <SectionContent
  //       sx={{
  //         opacity: useCurrentDate ? 0.5 : 1,
  //         pointerEvents: useCurrentDate ? "none" : "auto",
  //       }}
  //     >
  //       <Box sx={{ mb: 2 }}>
  //         <LocalizationProvider dateAdapter={AdapterDayjs}>
  //           <DatePicker
  //             label="날짜 선택"
  //             value={selectedDate}
  //             onChange={(newValue) => setSelectedDate(newValue)}
  //             disabled={useCurrentDate}
  //             format="YYYY/MM/DD"
  //             slotProps={{
  //               textField: {
  //                 fullWidth: true,
  //                 sx: {
  //                   "& .MuiInputBase-root": {
  //                     color: "#ffffff !important",
  //                     backgroundColor: "rgba(255, 255, 255, 0.05)",
  //                   },
  //                   "& .MuiInputBase-input": {
  //                     color: "#ffffff !important",
  //                   },
  //                   "& .MuiInputLabel-root": {
  //                     color: "#ffffff !important",
  //                   },
  //                   "& .MuiInputLabel-root.Mui-focused": {
  //                     color: "#ffffff !important",
  //                   },
  //                   "& .MuiOutlinedInput-notchedOutline": {
  //                     borderColor: "#464646 !important",
  //                   },
  //                   "&:hover .MuiOutlinedInput-notchedOutline": {
  //                     borderColor: "#ffffff !important",
  //                   },
  //                   "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
  //                     borderColor: "#1976d2 !important",
  //                   },
  //                   "& .MuiSvgIcon-root": {
  //                     color: "#ffffff !important",
  //                   },
  //                 },
  //               },
  //               popper: {
  //                 sx: {
  //                   "& .MuiPaper-root": {
  //                     backgroundColor: "#121212 !important",
  //                     color: "#ffffff !important",
  //                   },
  //                   "& .MuiPickersDay-root": {
  //                     color: "#ffffff !important",
  //                   },
  //                   "& .MuiPickersDay-root.Mui-selected": {
  //                     backgroundColor: "#1976d2 !important",
  //                   },
  //                   "& .MuiPickersCalendarHeader-root": {
  //                     color: "#ffffff !important",
  //                   },
  //                   "& .MuiSvgIcon-root": {
  //                     color: "#ffffff !important",
  //                   },
  //                 },
  //               },
  //             }}
  //           />
  //         </LocalizationProvider>
  //       </Box>
  //       <StyledFormControlLabel
  //         control={
  //           <Checkbox
  //             checked={dateSelectionEnabled}
  //             onChange={handleDateSelectionEnabledChange}
  //             disabled={useCurrentDate}
  //           />
  //         }
  //         label="날짜 직접 선택"
  //       />
  //     </SectionContent>
  //     <Divider />
  //     <DialogActions sx={{ padding: "1rem", backgroundColor: "#121212" }}>
  //       <Button
  //         onClick={handleSave}
  //         variant="contained"
  //         size="small"
  //         sx={{ minWidth: 80 }}
  //       >
  //         저장
  //       </Button>
  //       <Button
  //         onClick={handleClose}
  //         variant="outlined"
  //         size="small"
  //         sx={{
  //           minWidth: 80,
  //           color: "#ffffff",
  //           borderColor: "#464646",
  //           "&:hover": {
  //             borderColor: "#ffffff",
  //           },
  //         }}
  //       >
  //         닫기
  //       </Button>
  //     </DialogActions>
  //   </StyledDialog>
  // );
}

export default DateModal;
